// TC Kimlik Numarası Doğrulama Fonksiyonu
export const validateTCNumber = (value) => {
    // 11 haneli olmalı
    if (!value || value.length !== 11) {
        return false;
    }

    // Sadece rakamlardan oluşmalı
    if (!/^[0-9]+$/.test(value)) {
        return false;
    }

    // İlk rakam 0 olamaz
    if (value[0] === '0') {
        return false;
    }

    // Algoritma kontrolleri
    // 1, 3, 5, 7, 9. hanelerin toplamı
    const oddSum = parseInt(value[0]) + parseInt(value[2]) + parseInt(value[4]) +
        parseInt(value[6]) + parseInt(value[8]);

    // 2, 4, 6, 8. hanelerin toplamı
    const evenSum = parseInt(value[1]) + parseInt(value[3]) + parseInt(value[5]) +
        parseInt(value[7]);

    // 10. hane kontrolü: (oddSum * 7 - evenSum) % 10
    const tenthDigitCheck = (oddSum * 7 - evenSum) % 10;
    if (tenthDigitCheck !== parseInt(value[9])) {
        return false;
    }

    // 11. hane kontrolü: (İlk 10 hanenin toplamı) % 10
    const eleventhDigitCheck = (oddSum + evenSum + parseInt(value[9])) % 10;
    if (eleventhDigitCheck !== parseInt(value[10])) {
        return false;
    }

    return true;
};

// Eğitim durumu seçenekleri
export const educationOptions = [
    { value: 'ilkokul', label: 'İlkokul' },
    { value: 'ortaokul', label: 'Ortaokul' },
    { value: 'lise', label: 'Lise' },
    { value: 'onlisans', label: 'Ön Lisans' },
    { value: 'lisans', label: 'Lisans' },
    { value: 'yukseklisans', label: 'Yüksek Lisans' },
    { value: 'doktora', label: 'Doktora' }
];

// Çalışma şekli seçenekleri
export const employmentTypeOptions = [
    { value: 'çalışan', label: 'Çalışan (Maaşlı)' },
    { value: 'işveren', label: 'İşveren / İşyeri Sahibi' },
    { value: 'serbest', label: 'Serbest Meslek' },
    { value: 'emekli', label: 'Emekli' },
    { value: 'çalışmıyor', label: 'Çalışmıyor' }
];

// Çalışma süresi seçenekleri
export const employmentDurationOptions = [
    { value: '0-1', label: '0-1 Yıl' },
    { value: '1-3', label: '1-3 Yıl' },
    { value: '3-5', label: '3-5 Yıl' },
    { value: '5-10', label: '5-10 Yıl' },
    { value: '10+', label: '10+ Yıl' }
];

// Şehirler listesi
export const cities = [
    'Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Amasya', 'Ankara', 'Antalya', 'Artvin', 'Aydın', 'Balıkesir',
    'Bilecik', 'Bingöl', 'Bitlis', 'Bolu', 'Burdur', 'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır',
    'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir', 'Gaziantep', 'Giresun', 'Gümüşhane', 'Hakkari', 'Hatay',
    'Isparta', 'Mersin', 'İstanbul', 'İzmir', 'Kars', 'Kastamonu', 'Kayseri', 'Kırklareli', 'Kırşehir', 'Kocaeli',
    'Konya', 'Kütahya', 'Malatya', 'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş', 'Nevşehir', 'Niğde', 'Ordu',
    'Rize', 'Sakarya', 'Samsun', 'Siirt', 'Sinop', 'Sivas', 'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Şanlıurfa',
    'Uşak', 'Van', 'Yozgat', 'Zonguldak', 'Aksaray', 'Bayburt', 'Karaman', 'Kırıkkale', 'Batman', 'Şırnak', 'Bartın',
    'Ardahan', 'Iğdır', 'Yalova', 'Karabük', 'Kilis', 'Osmaniye', 'Düzce'
];